module.exports = __webpack_public_path__ + "img/logo.84593f02.png";